import { clsx } from 'clsx';
import styles from './PageLoader.module.scss';

interface PageLoaderProps {
  className?: string;
}

export function PageLoader({ className }: PageLoaderProps) {
  return (
    <div className={clsx(styles.container, className)}>
      <div className={styles.animationContainer}>
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={styles.bolt1}
        >
          <path
            d="M24.5082 12.5677C24.1922 11.8063 23.4842 11.333 22.6602 11.333L18.8509 11.4264L21.1389 6.125C21.4069 5.505 21.3442 4.797 20.9735 4.23433C20.6029 3.67033 19.9775 3.33301 19.3029 3.33301H13.3296C12.2122 3.33301 11.2856 4.03168 10.9229 5.12368L7.43357 14.033C7.22691 14.6503 7.3269 15.3063 7.70823 15.8343C8.08957 16.3623 8.68026 16.6663 9.33226 16.6663L13.0976 16.5783L9.25088 27.7837C9.15088 28.077 9.26555 28.401 9.52822 28.565C9.63755 28.633 9.75891 28.6663 9.88157 28.6663C10.0536 28.6663 10.2242 28.5997 10.3536 28.4717L24.0762 14.7477C24.6576 14.165 24.8229 13.329 24.5082 12.5677Z"
            fill="#2D2DF0"
          />
        </svg>
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={styles.bolt2}
        >
          <path
            d="M24.5082 12.5677C24.1922 11.8063 23.4842 11.333 22.6602 11.333L18.8509 11.4264L21.1389 6.125C21.4069 5.505 21.3442 4.797 20.9735 4.23433C20.6029 3.67033 19.9775 3.33301 19.3029 3.33301H13.3296C12.2122 3.33301 11.2856 4.03168 10.9229 5.12368L7.43357 14.033C7.22691 14.6503 7.3269 15.3063 7.70823 15.8343C8.08957 16.3623 8.68026 16.6663 9.33226 16.6663L13.0976 16.5783L9.25088 27.7837C9.15088 28.077 9.26555 28.401 9.52822 28.565C9.63755 28.633 9.75891 28.6663 9.88157 28.6663C10.0536 28.6663 10.2242 28.5997 10.3536 28.4717L24.0762 14.7477C24.6576 14.165 24.8229 13.329 24.5082 12.5677Z"
            fill="#2D2DF0"
          />
        </svg>
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={styles.bolt3}
        >
          <path
            d="M24.5082 12.5677C24.1922 11.8063 23.4842 11.333 22.6602 11.333L18.8509 11.4264L21.1389 6.125C21.4069 5.505 21.3442 4.797 20.9735 4.23433C20.6029 3.67033 19.9775 3.33301 19.3029 3.33301H13.3296C12.2122 3.33301 11.2856 4.03168 10.9229 5.12368L7.43357 14.033C7.22691 14.6503 7.3269 15.3063 7.70823 15.8343C8.08957 16.3623 8.68026 16.6663 9.33226 16.6663L13.0976 16.5783L9.25088 27.7837C9.15088 28.077 9.26555 28.401 9.52822 28.565C9.63755 28.633 9.75891 28.6663 9.88157 28.6663C10.0536 28.6663 10.2242 28.5997 10.3536 28.4717L24.0762 14.7477C24.6576 14.165 24.8229 13.329 24.5082 12.5677Z"
            fill="#2D2DF0"
          />
        </svg>
      </div>
    </div>
  );
}
